<template>
  <div>
    <section class="section hide_mobile">
      <div class="container">
        <div class="workshop-hero">
          <img :src="image" alt="Sign up as a trainer" class="img-fluid" />
          <div class="workshop_hero_content">
            <h3 class="workshop__text" :style="{color}">
              {{ title }}
            </h3>
            <p class="workshop_desc" :style="{color}" v-html="body">
<!--              {{ body }}-->
            </p>
            <slot name="btn"></slot>
          </div>
        </div>
      </div>
    </section>

    <section class="section mobile_hero hide_desktop">
      <slot></slot>
    </section>
  </div>
</template>

<script>
export default {
  props: ["image", "title", "body", "color"]
};
</script>
